import React from 'react';

export interface VoiceQuickPickOption {
  id: number;
  name: string;
  index: number;
  quote_number?: string;
}

interface VoiceQuickPicksProps {
  options: VoiceQuickPickOption[];
  onSelect: (option: VoiceQuickPickOption) => void;
  disabled?: boolean;
}

const VoiceQuickPicks: React.FC<VoiceQuickPicksProps> = ({ options, onSelect, disabled }) => {
  if (!options.length) return null;

  return (
    <div className="gva-quick-picks" role="group" aria-label="Quick picks">
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          className="gva-quick-pick-btn"
          disabled={disabled}
          onClick={() => onSelect(option)}
        >
          <span className="gva-quick-pick-index">{option.index}</span>
          <span className="gva-quick-pick-name">{option.name}</span>
        </button>
      ))}
    </div>
  );
};

export default VoiceQuickPicks;
